export default "__VITE_ASSET__BI9yaw9U__"